import './App.css';
// import Banner from './components/Banner';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Footer from './components/Footer';
import Home from './components/Home';
import About from "./components/About";
import Destination from "./components/Destination";
import Gallery from "./components/Gallery";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Contact from './components/Contact';
import Header from './components/Header';
import RoadTrip from './components/RoadTrip';
import Hillstation from './components/Hillstation';
import Adventure from './components/Adventure';
import NightLife from './components/NightLife';
import Historicplaces from './components/Historicplaces';
import Beaches from './components/Beaches';
import Login from './components/Login';
import ResortDetails from './components/ResortDetails';
import Signup from './components/Signup';
import BlogDetails from"./components/BlogDetails";
import BookingForm from "./components/BookingForm"
import ARViewer from './components/ARViewer';



function App() {
  return (
   <>
    <Router basename="/" >
        <Header />
        <Routes >
        
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/destination" element={<Destination />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
            <Route path="/booking" element={<BookingForm />} />

          <Route path="/resort/:resortName" element={<ResortDetails />} />
          {/* <Route path="/resort/:resortName" element={<ARViewer />} /> */}
          <Route path="/blog/:slug" element={<BlogDetails />} />
          {/* <Route path="" element={<ARViewer />} /> */}


      
      
        <Route path="/RoadTrip" element={<RoadTrip />} />
        <Route path="/Hillstation" element={<Hillstation />} />
        <Route path="/Adventure" element={<Adventure />} />
        <Route path="/NightLife" element={<NightLife />} />
        <Route path="/historicplaces" element={<Historicplaces />} />
        <Route path="/Beaches" element={<Beaches />} />

          {/* <Route path="/" element={<CategoryActivities />} /> */}
        {/* <Route path="/hill-station" element={<HillStation />} />
        <Route path="/adventure" element={<Adventure />} />
        <Route path="/night-life" element={<NightLife />} />
        <Route path="/historic-places" element={<HistoricPlaces />} />
        <Route path="/beaches" element={<Beaches />} /> */}
          
        </Routes>
    </Router>
   
   <Footer />
   </>
  );
}

export default App;
